import React, { Fragment, useEffect } from "react";
import * as PropTypes from "prop-types";
import { PlusOutlined } from "@ant-design/icons";
import MemberDropdown from "./MemberDropdown";
import RemoveButtonGroup from "./RemoveButtonGroup";
import { useSelector, useDispatch } from "react-redux";

import { SectionRow, Select, Input } from "../components";
import { setDynamicFilters } from "../../report/reportSlice";
const DynamicFilterGroup = ({ availableMembers, addMemberName, intl }) => {
  const dispatch = useDispatch();
  const dynamicFilters = useSelector((state) => state.report.dynamicFilters);
  const activeReport = useSelector((state) => state.report.activeReport);

  useEffect(() => {
    let initialFilters = [];
    if (
      activeReport &&
      activeReport.dynamic_filters &&
      activeReport.dynamic_filters.length > 0 &&
      availableMembers &&
      availableMembers.length > 0
    ) {
      activeReport.dynamic_filters.forEach((el, index) => {
        const dimension = availableMembers.filter(
          (i) => i.name === el.member
        )[0];

        const operators =
          operatorsOptions[dimension?.meta?.type || dimension?.type] ||
          operatorsOptions.string;
        initialFilters.push({ ...el, dimension, operators, id: index });
      });
    }
    if (dynamicFilters.length === 0) {
      dispatch(setDynamicFilters(initialFilters));
    }
  }, [activeReport, availableMembers, dispatch]);

  const addFilter = (val) => {
    const operators =
      operatorsOptions[val?.dimension?.meta?.type || val.dimension.type] ||
      operatorsOptions.string;
    const id =
      dynamicFilters
        .map((i) => i.id)
        .reduce((partialSum, a) => partialSum + a, 0) + 1;
    dispatch(
      setDynamicFilters([
        ...dynamicFilters,
        { ...val, member: val.dimension.name, operators, id },
      ])
    );
  };

  const updateFilter = (val) => {
    const filtered = [...dynamicFilters].filter((i) => i.id !== val.id);
    const operators =
      operatorsOptions[val?.dimension?.meta?.type || val.dimension.type] ||
      operatorsOptions.string;
    dispatch(
      setDynamicFilters([
        ...filtered,
        { ...val, member: val.dimension.name, operators },
      ])
    );
  };

  const removeFilter = (val) => {
    const filtered = [...dynamicFilters].filter((i) => i.id !== val);
    dispatch(setDynamicFilters(filtered));
  };

  const operatorsOptions = {
    string: [
      { name: "contains", title: "contains" },
      { name: "notContains", title: "does not contain" },
      { name: "equals", title: "equals" },
      { name: "notEquals", title: "does not equal" },
      { name: "set", title: "is set" },
      { name: "notSet", title: "is not set" },
    ],

    number: [
      { name: "equals", title: "equals" },
      { name: "notEquals", title: "does not equal" },
      { name: "set", title: "is set" },
      { name: "notSet", title: "is not set" },
      { name: "gt", title: ">" },
      { name: "gte", title: ">=" },
      { name: "lt", title: "<" },
      { name: "lte", title: "<=" },
    ],
    time: [
      { name: "equals", title: "equals" },
      { name: "notEquals", title: "does not equal" },
      { name: "inDateRange", title: "in date range" },
      { name: "notInDateRange", title: "not in date range" },
      { name: "afterDate", title: "after date" },
      { name: "beforeDate", title: "before date" },
      { name: "set", title: "is set" },
      { name: "notSet", title: "is not set" },
    ],
    boolean: [
      { name: "equals", title: "equals" },
      { name: "notEquals", title: "does not equal" },
    ],
  };
  return (
    <SectionRow>
      {dynamicFilters.map((m) => (
        <Fragment key={m.id}>
          <RemoveButtonGroup onRemoveClick={() => removeFilter(m.id)}>
            <MemberDropdown
              onClick={(updateWith) =>
                updateFilter({ ...m, dimension: updateWith })
              }
              availableMembers={availableMembers}
              style={{
                width: 150,
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
              intl={intl}
            >
              {intl.formatMessage({
                id: `app.analytics.${m.dimension?.name}`,
                defaultMessage: `${m?.dimension?.title}`,
              })}
            </MemberDropdown>
          </RemoveButtonGroup>
          <Select
            value={m.operator}
            onChange={(operator) => updateFilter({ ...m, operator })}
            style={{ width: 200 }}
            placeholder={intl.formatMessage({
              id: `app.analytics.operator`,
            })}
          >
            {m.operators.map((operator) => (
              <Select.Option key={operator.name} value={operator.name}>
                {intl.formatMessage({
                  id: `app.reports.${operator.title}`,
                })}
              </Select.Option>
            ))}
          </Select>
          <Input
            key="input"
            style={{ width: 300 }}
            onChange={(e) => updateFilter({ ...m, name: e.target.value })}
            value={m.name}
            placeholder={intl.formatMessage({
              id: `app.analytics.dynamicFilterName`,
            })}
          />
        </Fragment>
      ))}
      <MemberDropdown
        onClick={(m) => addFilter({ dimension: m })}
        availableMembers={availableMembers}
        type="dashed"
        icon={<PlusOutlined />}
        intl={intl}
      >
        {!dynamicFilters.length ? addMemberName : null}
      </MemberDropdown>
    </SectionRow>
  );
};

DynamicFilterGroup.propTypes = {
  availableMembers: PropTypes.array.isRequired,
  addMemberName: PropTypes.string.isRequired,
};

export default DynamicFilterGroup;
